
// controllers/positioncategories_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["positionSelect"]

    connect() {
        // Optional: initiales Setup
        console.log("✅ positioncategories_controller connected")
    }

    update(event) {
        const functionalareaId = event.target.value

        if (!functionalareaId) {
            this.positionSelectTarget.innerHTML = "" // leeren, wenn keine Auswahl
            return
        }

        fetch(`/functionalareas/${functionalareaId}/load_positioncategories`, {
            headers: {
                Accept: "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.positionSelectTarget.innerHTML = ""

                // Prompt-Option
                const promptOption = document.createElement("option")
                promptOption.value = ""
                promptOption.textContent = this.positionSelectTarget.dataset.prompt || "--- bitte wählen ---"
                this.positionSelectTarget.appendChild(promptOption)

                // Neue Optionen hinzufügen
                data.forEach(pc => {
                    const option = document.createElement("option")
                    option.value = pc.id
                    option.textContent = pc.name
                    this.positionSelectTarget.appendChild(option)
                })
            })
    }
}